// src/components/LoadingScreen.jsx

import React from 'react';

export default function LoadingScreen({ message }) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#1A1D24] text-white flex-col">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500 mb-4"></div>
            <p className="text-xl text-gray-400">{message || "Loading..."}</p>
        </div>
    );
}